// extracted by mini-css-extract-plugin
module.exports = {"dropdownContainer":"styles_dropdownContainer__DFp9x","defaultTriggerClassName":"styles_defaultTriggerClassName__nLRI4"};